// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4ad990b0","635":"6e9063a9"}[chunkId] + ".chunk.js";
};